import React from "react";

export const PageNotes: React.FunctionComponent<{children:React.JSX.Element}> = ({children})=>{
 return (
   <div className="my-3 mb-5">
     <hr />
     <p className="fw-bold">NOTES:</p>
     {children}
   </div>
 )
}
